<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 前台已登录会话：刷新真实权限码（捕获角色/授权变更）
    if (this.$store.state.user.token) {
      this.$store.dispatch('user/fetchFrontPerms')
    }
  }
}
</script>
